import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalBody, Button } from "reactstrap";
import './counter.module.css';
import StudentsService from "../services/StudentsService";

export default function OptInModal(props) {
    const [isLoading, setIsLoading] = useState(false);

    const fundraiserDevice = props.fundraiserDevice;
    if (!fundraiserDevice) {
        return <div>Loading...</div>;
    }

    const modal = props.modalStatus;
    const phone = fundraiserDevice.phone;
    const close = () => { props.deactivate() };

    const disableReminders = () => {
        setIsLoading(true);
        StudentsService.UpdateOptInStatus({
            phone: phone,
            status: false
        }).then(() => {
            setIsLoading(false);
            close();
        });
    };

    return (
        <Modal isOpen={modal} toggle={close}>
            <ModalBody>
                <div className="row d-flex justify-content-center">
                    <h3 className="text-center">Benefits of Fundraiser Reminders</h3>
                    <p>
                        Reminders have been shown to improve fundraiser performance by up to 20%!
                        Your information will never be shared, and your phone number will only be used for these two messages:
                        <br />
                        <a
                            href="https://fundraisingu.net/safety/text-messaging/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#0e456c' }}
                        >
                            Text Messaging (TCPA)
                        </a>
                    </p>
                    <ul className="ms-4">
                        <li>One text two days after the fundraiser kickoff</li>
                        <li>One text when there are two days left in the fundraiser</li>
                    </ul>
                    <div className="mt-3 text-center">
                        <Button 
                            color="secondary" 
                            onClick={close} 
                            disabled={isLoading}
                            className="me-2"
                            style={{ borderColor: '#5a6268' }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            color="light" 
                            onClick={disableReminders} 
                            disabled={isLoading}
                            style={{ borderColor: '#dee2e6' }}
                        >
                            Disable
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}
